import React from 'react';
import moment from 'moment';
import { DatePicker, TimePicker, Radio } from 'antd';
import { getDateRequiredRule, getDisabledNumbers } from './utils';
import { containerIds } from '../../constants/containerIds';
import styles from './ItemToCalendarForm.module.scss';

export const DATE_PICKER_FORMAT = 'D MMMM YYYY';

export const fieldNames = {
  date: 'date',
  startTime: 'startTime',
  endTime: 'endTime',
};

const periodNames = {
  all: 'all',
  firstHalf: 'firstHalf',
  secondHalf: 'secondHalf',
};

export const periods = {
  [periodNames.all]: {
    name: periodNames.all,
    start: '09:00',
    end: '18:00',
  },
  [periodNames.firstHalf]: {
    name: periodNames.firstHalf,
    start: '09:00',
    end: '13:00',
  },
  [periodNames.secondHalf]: {
    name: periodNames.secondHalf,
    start: '14:00',
    end: '18:00',
  },
};

export const renderedPeriods = [
  {
    title: 'В течении дня',
    value: periodNames.all,
  },
  {
    title: 'В I половине',
    value: periodNames.firstHalf,
  },
  {
    title: 'В II половине',
    value: periodNames.secondHalf,
  },
];

export const formFields = [
  {
    label: 'Дата',
    name: fieldNames.date,
    getInitialValue: (initialValues) =>
      initialValues?.fromDate && moment(initialValues.fromDate),
    rules: [getDateRequiredRule('Укажите дату')],
    renderComponent: ({ onChange }) => (
      <DatePicker
        format={DATE_PICKER_FORMAT}
        allowClear={false}
        className={styles.picker}
        showToday={false}
        onChange={onChange}
        getCalendarContainer={() =>
          document.getElementById(containerIds.localTaskPopover)
        }
      />
    ),
  },
  {
    periodsField: true,
    renderComponent: ({ value, onChange }) => (
      <Radio.Group
        key="periods"
        onChange={onChange}
        value={value}
        style={{ marginBottom: '12px' }}
      >
        {renderedPeriods.map((period) => (
          <Radio.Button
            key={period.value}
            value={period.value}
          >
            {period.title}
          </Radio.Button>
        ))}
      </Radio.Group>
    ),
  },
  {
    label: 'Начало',
    name: fieldNames.startTime,
    getInitialValue: (initialValues) =>
      initialValues?.fromDate && moment(initialValues.fromDate),
    rules: [getDateRequiredRule('Укажите начало периода')],
    renderComponent: ({ onChange }) => (
      <TimePicker
        allowClear={false}
        format="HH:mm"
        minuteStep={30}
        className={styles.picker}
        inputReadOnly
        onChange={onChange}
        getPopupContainer={() =>
          document.getElementById(containerIds.localTaskPopover)
        }
      />
    ),
  },
  {
    label: 'Окончание',
    name: fieldNames.endTime,
    getInitialValue: (initialValues) =>
      initialValues?.toDate && moment(initialValues.toDate),
    rules: [getDateRequiredRule('Укажите окончание периода')],
    renderComponent: ({ onChange, startTime, endTime }) => (
      <TimePicker
        allowClear={false}
        format="HH:mm"
        minuteStep={30}
        className={styles.picker}
        onChange={onChange}
        hideDisabledOptions
        inputReadOnly
        getPopupContainer={() =>
          document.getElementById(containerIds.localTaskPopover)
        }
        disabledHours={() => {
          const hour = startTime ? startTime.hour() : 0;
          const minute = startTime ? startTime.minute() : 0;
          const disabledArr = getDisabledNumbers(hour);

          return minute === 0
            ? disabledArr.slice(1)
            : disabledArr.slice(1).concat(disabledArr.length);
        }}
        disabledMinutes={() => {
          if (endTime && endTime.hour() === 0) {
            return [30];
          }

          return [];
        }}
      />
    ),
  },
];
